(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbn-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dbn-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.dbn-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.dbn-reveal').forEach(function (el) { el.classList.add('dbn-in'); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbn-inside-book"] && !Shopify.designMode) return;
  try {
    
(function () {
  var inner = document.querySelector('.dbn-ib-inner');
  if (!inner) return;
  var chaps = Array.from(inner.querySelectorAll('.dbn-chap'));
  if (chaps.length === 0) return;
  var label = inner.dataset.tocLabel || 'See all chapters';
  var details = document.createElement('details');
  details.className = 'dbn-more-toc';
  var summary = document.createElement('summary');
  summary.textContent = label;
  details.appendChild(summary);
  var tocInner = document.createElement('div');
  tocInner.className = 'dbn-toc-inner';
  chaps.forEach(function (el) { tocInner.appendChild(el); });
  details.appendChild(tocInner);
  inner.appendChild(details);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbn-interviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var outer = document.querySelector('.dbn-int-outer');
  if (!outer) return;
  var track = outer.querySelector('.dbn-int-track');
  var prev = outer.querySelector('.dbn-int-prev');
  var next = outer.querySelector('.dbn-int-next');
  function scrollAmt() {
    var card = track.querySelector('.dbn-int-card');
    if (!card) return 200;
    return (card.offsetWidth + 16) * 2;
  }
  prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmt(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left: scrollAmt(), behavior: 'smooth' }); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbn-pattern"] && !Shopify.designMode) return;
  try {
    
(function () {
  var fig = document.querySelector('.dbn-battery-fig');
  if (!fig) return;
  var fill = fig.querySelector('.dbn-batt-fill');
  var num = fig.querySelector('.dbn-batt-num');
  var target = parseInt(num.dataset.target, 10) || 14;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var run = function () {
    fill.style.width = target + '%';
    if (reduce) { num.textContent = target; return; }
    var c = 0;
    var iv = setInterval(function () { c++; num.textContent = c; if (c >= target) clearInterval(iv); }, 55);
  };
  if ('IntersectionObserver' in window) {
    var bo = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { run(); bo.unobserve(e.target); } });
    }, { threshold: 0.4 });
    bo.observe(fig);
  } else { run(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
